import { render, staticRenderFns } from "./SimpleArticle.vue?vue&type=template&id=550055f4"
import script from "./SimpleArticle.vue?vue&type=script&lang=js"
export * from "./SimpleArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports